import { atom } from 'jotai';
import { MarketNews } from '../../types';
import { Loadable, LoadableState } from '../../utils';

export type ErsteMarketNewsState = LoadableState<MarketNews[]>;

export type ErsteMarketNewsAtomState = {
  news: ErsteMarketNewsState;
  hasMore: boolean;
  currentPage: number;
};

export const ersteMarketNewsAtom = atom<ErsteMarketNewsAtomState>({
  news: Loadable.loading,
  hasMore: true,
  currentPage: 1,
});
